import pluralize from 'pluralize';
import { prop, propEq, when } from 'ramda';

import { ITINERARIES_ITEM_TYPES } from 'constants/index';
import { ITINERARIES_PATH } from 'constants/routes';
import { isItineraries, isLookbook } from 'utils/itineraries/functions';
import { isNotDefined } from 'utils/ramda';

export const getIsSamplePreviewDefault = ({ content, path }) => {
  return isItineraries(content) || isLookbook(content) || path === ITINERARIES_PATH;
};

export const getPreviewFetchArgs = ({ itinerary, pageId }) => {
  if (isNotDefined(itinerary)) return [pageId];

  return [itinerary.id, pluralize(itinerary.type)];
};

const isGuestPortal = propEq(ITINERARIES_ITEM_TYPES.GUEST_PORTAL, 'type');
export const getPageInfo = when(isGuestPortal, prop('itinerary'));
